import React, { useState } from 'react';
import { useUser } from '../utils/UserContext';
import TabBar from '../components/shared/TabBar';
import InnerTabsd from '../components/shared/InnerTabsd';
import { EditIcon, UserIcon2, PlusIcon, DocumentIcon2, EmailIcon, DollarIcon } from '../components/shared/Icons';
import EmployeePayslips from './EmployeePayslips';
import SendPayrolEmails from './SendPayrolEmails';
import SubbiePoNumCreation from './SubbiePoNumCreation';
import SendSubbiePOEmail from './SendSubbiePOEmail';
import SitesManagement from './SitesManagement';
import UsersManagement from './UsersManagement';
import SubbiePayments from './SubbiePayments';
import HigherView from './HigherView';
import EmployeePayments from './EmployeePayments';
import Dashboard from './Dashboard';
import OnboardingForm from '../components/onboarding/OnboardingForm';
import OnboardActive from './OnboardActive';
import UsersCompliance from './UsersCompliance';
import ActiveReplacements from './ActiveReplacements';
import SubcontractorComplete from './SubcontractorComplete';



const TABS = [
  {
    id: 'dashboardmain',
    label: 'Dashboard',
  },
  {
    id: 'database',
    label: 'Database',
  },
  {
    id: 'onboardnewall2',
    label: 'Onboarding Staff',
  },
  {
    id: 'payroll',
    label: 'Employee Payroll',
  },
  {
    id: 'subbie',
    label: 'Subcontractor Payments',
  },
];





const SNLDATABASE_INNER = [
  { id: 'userallfinalonboard2', label: 'Final Activation', icon: <UserIcon2 />, component: SubcontractorComplete },
   { id: 'userallstatus', label: 'Manage Users', icon: <UserIcon2 />, component: UsersManagement },
   { id: 'userallcompliance', label: 'Users Compliance', icon: <UserIcon2 />, component: UsersCompliance },
  { id: 'sitesall', label: 'Manage Clients', icon: <UserIcon2 />, component: SitesManagement },
 
  
];


const ONBOARDNEW_INNER = [
  { id: 'onboardnew3', label: 'Create New User', icon: <PlusIcon />, component: OnboardingForm },
  { id: 'onboardactive3', label: 'Onboarding', icon: <EditIcon />, component: OnboardActive },
  { id: 'userallfinalonboard3', label: 'Final Activation', icon: <UserIcon2 />, component: SubcontractorComplete },
  
 
  
];


const SNLPAYROLL_INNER = [
  { id: 'payslips_data', label: 'Create Payslips', icon: <UserIcon2 />, component: EmployeePayslips },
  { id: 'email_payslips', label: 'Send Emails', icon: <EmailIcon />, component: SendPayrolEmails },
  { id: 'po_employee', label: 'Employee Payments', icon: <DollarIcon />, component: EmployeePayments },
  { id: 'po_higherviewe', label: 'Expenses Overview', icon: <DollarIcon />, component: HigherView },
  
];

const SUBBIE_INNER = [
    { id: 'po_creation', label: 'Create PO Numbers', icon: <DocumentIcon2 />, component: SubbiePoNumCreation },
    { id: 'po_emails', label: 'Send PO Emails', icon: <EmailIcon />, component: SendSubbiePOEmail },
    { id: 'po_subbie', label: 'Subbie Payments', icon: <DollarIcon />, component: SubbiePayments },
    { id: 'po_higherview', label: 'Expenses Overview', icon: <DollarIcon />, component: HigherView },
  ];

  const DASHBOARDSUPERVISOR_INNER = [
  { id: 'dashboadall', label: 'Main Dashboard', icon: <UserIcon2 />, component: Dashboard },
  { id: 'replacementactive3', label: 'Replacement', icon: <UserIcon2 />, component: ActiveReplacements },
 
  
  
];

const FiltersAdminPage2 = () => {
  
  const [activeTab, setActiveTab] = useState('dashboardmain');
  const { homeAccent } = useUser();

  
  

  


  return (
    <div className="fr-tab-page">
      <TabBar
        tabs={TABS}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        homeRoute="/profile"
        homeColor={homeAccent}
      />
      <div className="fr-tab-content">
       {activeTab === 'dashboardmain' && <InnerTabsd tabs={DASHBOARDSUPERVISOR_INNER} defaultId="dashboadall"/>}
        {activeTab === 'database' && <InnerTabsd tabs={SNLDATABASE_INNER}  defaultId="userallstatus" />}
        {activeTab === 'onboardnewall2' && <InnerTabsd tabs={ONBOARDNEW_INNER} defaultId="onboardnew3"/>}
        {activeTab === 'payroll' && <InnerTabsd tabs={SNLPAYROLL_INNER} defaultId="payslips_data"/>}
        {activeTab === 'subbie' && <InnerTabsd tabs={SUBBIE_INNER} defaultId="po_creation" />}
      </div>
    </div>
  );
};



export default FiltersAdminPage2;